<template>
	<div
		data-testid="processamento-avancado-component"
		class="container__processamento__avancado"
	>
		<!-- <h1>{{`${$t('processing')} > ${isCubagem ? $t('logging') : $t('inventory')} > ${$t('model')}`}}</h1> -->
		<div class="content__processamento__avancado">
			<Card
				style="background-color: white; height: 100%"
				class="settings__section"
				data-testid="advanced-processing-settings-section"
			>
				<div
					style="
						display: flex;
						justify-content: space-between;
						flex-direction: column;
						height: 100%;
					"
				>
					<slot name="registry-fields" />
					<slot name="action-buttons" />
				</div>
			</Card>
			<Card
				style="background-color: white; height: 100%"
				class="chart__section"
				data-testid="advanced-processing-chart-section"
			>
				<slot name="modeling-preview" />
			</Card>
			<!-- <Card
        style="background-color: white; height: 100%"
        class="statistics__section"
        data-testid="advanced-processing-statistics-section"
      >
        <div style="display: flex; justify-content: space-between; flex-direction: column; height: 100%">
          <slot name="checkout-preview" />
        </div>

      </Card> -->
		</div>
	</div>
</template>

<script>
import Card from '../../components/Card/Card.vue'

export default {
	components: {
		Card,
	},
	props: {
		modelo: {
			type: Object,
			required: false,
		},
	},
	computed: {
		isCubagem() {
			return window.location.pathname === '/cubagem'
		},
	},
}
</script>

<style scoped>
/*
 * `bottom: 0` em vez de `height: 100%`: como o container e fixed em `top: var(--menu-height)`,
 * uma altura de 100vh somava o deslocamento do topo e vazava a viewport por baixo.
 * Com o `height: 93vh` do grid mais `margin-top: 1rem`, em notebook (768px) o total
 * passava de 100vh e os botoes de acao ficavam fora da tela. Agora a altura e o
 * espaco que sobra de fato, e o scroll acontece dentro dos cards.
 */
.container__processamento__avancado {
	position: fixed;
	left: 0;
	top: var(--menu-height);
	bottom: 0;
	width: 100vw;
	z-index: 0;
	font-size: 0.75rem;
	background-color: #f5f5f5;
	overflow: hidden;
}

.content__processamento__avancado {
	box-sizing: border-box;
	height: 100%;
	min-height: 0;
	display: grid;
	grid-template-columns: 1fr 3fr;
	gap: 0.5rem;
	padding: 1rem;
}

/*
 * Sem `min-height: 0` um item de grid nao encolhe abaixo do conteudo, entao o
 * card crescia e empurrava o proprio rodape para fora em vez de rolar por dentro.
 *
 * `auto` e nao `hidden`: quem rolava antes era o container externo, e nem todo
 * conteudo de slot tem rolagem propria (o ModelPreviewTemp nao tem). Com hidden,
 * conteudo mais alto que o card seria cortado em vez de rolar.
 */
.settings__section,
.chart__section {
	min-height: 0;
	overflow: auto;
}

h1 {
	margin-top: 1rem;
	margin-left: 1rem;
	font-size: 1.2rem;
	font-weight: 700;
	color: rgb(var(--color-primary));
}
</style>
